import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { IconsInitConfigType } from '../../../constants';
import { IconUIComponent } from '../icon/icon.component';

export const EmptyStateScreenPosition = { Absolute: 'absolute', Relative: 'relative' } as const;
export type EmptyStateScreenPosition =
  (typeof EmptyStateScreenPosition)[keyof typeof EmptyStateScreenPosition];

@Component({
  selector: 'fr8bot-empty-state-screen',
  host: {
    '[class.empty-state-screen-position-absolute]': 'isAbsolute',
  },
  imports: [NgClass, IconUIComponent],
  templateUrl: './empty-state-screen.component.html',
  styleUrl: './empty-state-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateScreenComponent {
  icon = input<IconsInitConfigType>();
  title = input<string>();
  description = input<string>();
  gradientBd = input(false);

  readonly position = input<EmptyStateScreenPosition>(EmptyStateScreenPosition.Relative);
  get isAbsolute() {
    return this.position() === EmptyStateScreenPosition.Absolute;
  }
}
